
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

export interface BookingDeletePayload {
  reason: "mistake" | "cancelled";
  instructorArrived: boolean | null;
}

@Component
export default class BookingDeleteDialog extends Vue {
  @Prop({ default: false }) readonly value!: boolean;
  /** True while the caller is performing the delete. */
  @Prop({ default: false }) readonly saving!: boolean;
  /** Whether the instructor on this booking is paid per day rather than salaried. */
  @Prop({ default: false }) readonly isOutsourceInstructor!: boolean;

  step: "confirm" | "reason" = "confirm";
  reason: "mistake" | "cancelled" | null = null;
  arrived: boolean | null = null;

  arrivedOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false }
  ];

  get open(): boolean {
    return this.value;
  }
  set open(val: boolean) {
    this.$emit("input", val);
  }

  get canSubmit(): boolean {
    if (this.reason === "mistake") return true;
    return this.reason === "cancelled" && this.arrived !== null;
  }

  /** Spell out the consequence, so nobody has to remember the rules. */
  get outcomeHint(): string {
    if (this.arrived === null) {
      return "";
    }
    if (!this.arrived) {
      return "No invoice is due. Any pre-invoice already raised for this booking will be removed.";
    }
    return this.isOutsourceInstructor
      ? "The instructor travelled, so an invoice stays open for the cancellation compensation fee only - no course fee and no travel."
      : "The instructor travelled, so an invoice stays open for their fuel only - no course fee and no overnight allowances.";
  }

  @Watch("value")
  onOpenChange(val: boolean): void {
    if (val) {
      this.step = "confirm";
      this.reason = null;
      this.arrived = null;
    }
  }

  @Watch("reason")
  onReasonChange(): void {
    // "Created by mistake" was never a real appointment, so nobody arrived.
    if (this.reason !== "cancelled") {
      this.arrived = null;
    }
  }

  cancel(): void {
    this.open = false;
    this.$emit("cancel");
  }

  submit(): void {
    if (!this.canSubmit || !this.reason) {
      return;
    }
    const payload: BookingDeletePayload = {
      reason: this.reason,
      instructorArrived: this.reason === "cancelled" ? this.arrived : null
    };
    this.$emit("confirm", payload);
  }
}
